import { Navigate, Outlet, useLocation } from "react-router";
import { useAuthStore } from "@/stores";

interface ProtectedRouteProps {
	children?: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
	const { isAuthenticated } = useAuthStore();
	const location = useLocation();

	if (!isAuthenticated) {
		// Redirect to login, but save the attempted location
		return <Navigate to="/login" state={{ from: location }} replace />;
	}

	// If children are provided, render them; otherwise use Outlet for nested routes
	return children ? children : <Outlet />;
}
